import React, { useState, useRef, useEffect, useMemo } from "react";

function SearchableStopPicker({ stops, value, onChange, placeholder = "Search stops..." }) {
    const [query, setQuery] = useState("");
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    // Find current stop name for display
    const selectedStop = stops.find((s) => s.id === value);

    // Filter stops by query
    const filtered = useMemo(() => {
        if (!query.trim()) return stops.slice(0, 50); // Show first 50 if no query
        const q = query.toLowerCase();
        return stops
            .filter((s) => s.name?.toLowerCase().includes(q) || s.id?.toLowerCase().includes(q))
            .slice(0, 50);
    }, [stops, query]);

    // Close dropdown on outside click
    useEffect(() => {
        function handleClick(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    function handleSelect(stop) {
        onChange(stop.id);
        setQuery("");
        setOpen(false);
    }

    function handleClear() {
        onChange("");
        setQuery("");
    }

    return (
        <div className="stop-picker" ref={wrapperRef}>
            <div className="stop-picker-input-wrap">
                <input
                    type="text"
                    className="stop-picker-input"
                    placeholder={selectedStop ? `${selectedStop.name} (${selectedStop.id})` : placeholder}
                    value={open ? query : ""}
                    onFocus={() => setOpen(true)}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        if (!open) setOpen(true);
                    }}
                />
                {value && (
                    <button className="stop-picker-clear" onClick={handleClear} title="Clear">✕</button>
                )}
            </div>
            {!open && selectedStop && (
                <div className="stop-picker-selected" onClick={() => setOpen(true)}>
                    📍 {selectedStop.name} <span className="stop-picker-id">({selectedStop.id})</span>
                </div>
            )}
            {open && (
                <ul className="stop-picker-dropdown">
                    {filtered.length === 0 ? (
                        <li className="stop-picker-empty">No stops found</li>
                    ) : (
                        filtered.map((s) => (
                            <li
                                key={s.id}
                                className={`stop-picker-option ${s.id === value ? "selected" : ""}`}
                                onClick={() => handleSelect(s)}
                            >
                                <span className="stop-picker-name">{s.name}</span>
                                <span className="stop-picker-id">{s.id}</span>
                            </li>
                        ))
                    )}
                    {filtered.length === 50 && (
                        <li className="stop-picker-hint">Type to search more stops...</li>
                    )}
                </ul>
            )}
        </div>
    );
}

export default SearchableStopPicker;
